import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getBatches } from '../../services'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import { GetBatchesRequest, GetBatchesResponse } from '@/modules/batches/type'

export default function useQueryGetBatches(
	payload: GetBatchesRequest,
	props?: UseBaseQueryOptions<GetBatchesResponse>,
) {
	return useQuery({
		queryKey: [BatchesQueryKeys.GetBatches, payload],
		queryFn: () => getBatches(payload),
		...props,
	})
}
